/**
 * Model for (Process) Task Definitions.
 */
export class TaskDefinition {
    key: string;
    name: string;
    description: string;
    guide: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/task-definition.model.ts